<div
  class="toast"
  *ngIf="toastService.message"
  @popUpDown
  [class.toast--success]="!toastService.message.error"
  [class.toast--error]="toastService.message.error"
>
  <div class="toast-message">{{ toastService.message.text }}</div>
  <div class="toast__close" (click)="close()">
    <svg class="em-c-icon em-c-icon--medium" (click)="close(); $event.stopPropagation()">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="../../assets/unity-1.3.0/images/24/em-icons.svg#x-filled"></use>
    </svg>
  </div>
</div>
